<nav aria-label="breadcrumb" class="nav-breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngFor="let item of breadcrumb">
        <a [routerLink]="item.path" (click)="openPage(item.path)" class="subtitle-small" [ngClass]="verificaURL(rotaAtual, item.path) ? 'breadcrumb-active' : ''">
          {{ item.label }}
        </a>
      </li>
    </ol>
</nav>